
const showKlaviyoNotifyModal = (state) => {
    var removeCartVisible = setInterval(function () {
        var rebuyCart = document.getElementById('rebuy-cart');
        if (rebuyCart && rebuyCart.classList.contains('is-visible')) {
            clearInterval(removeCartVisible);
            Rebuy.SmartCart.hide();
        }
    }, 100);
    document.querySelector('.klaviyo-notify-step-1').style.display = 'block';
    document.querySelector('.klaviyo-notify-step-2').style.display = 'none';
    document.getElementById('klaviyo-notify-modal').style.display = 'inherit';
    document.querySelectorAll('.klaviyo-notify-modal-title')[0].innerHTML = state.title ? state.title : '';
    document.querySelectorAll('.klaviyo-notify-modal-title')[1].innerHTML = state.title ? state.title : '';
    document.getElementById('klaviyo-notify-modal-product-id').setAttribute('value', state.product_id);
};

const hideKlaviyoNotifyModal = (state) => {
    document.querySelector('.klaviyo-notify-step-1').style.display = 'block';
    document.querySelector('.klaviyo-notify-step-2').style.display = 'none';
    document.getElementById('klaviyo-notify-modal').style.display = 'none';
    document.querySelector('#klaviyoNotifyForm .form-email').value = '';
    document.querySelector('body').classList.remove('rebuy-modal-visible');
};

const klaviyoNotifyForm = (e) => {
    e.preventDefault();

    const email = document.querySelector('#klaviyoNotifyForm .form-email').value;
    const variant_title = document.querySelector('.klaviyo-notify-modal-title').innerHTML;
    const product_id = document.getElementById('klaviyo-notify-modal-product-id').value;
    const key = 'Notify ' + variant_title;

    const options = {
        method: 'POST',
        headers: {
            accept: 'application/json',
            revision: '2024-06-15',
            'content-type': 'application/json',
        },
        body: JSON.stringify({
            data: {
                type: 'back-in-stock-subscription',
                attributes: {
                    channels: ['EMAIL'],
                    profile: { data: { type: 'profile', attributes: { email: email } } },
                },
                relationships: { variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${product_id}` } } },
            },
        }),
    };

    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=RDTVvi', options).then((response) => {
        console.group('Klaviyo API Response');
        console.log('EMAIL', email);
        console.log('RESPONSE', response);
        console.groupEnd();
    });

    document.querySelector('.klaviyo-notify-step-1').style.display = 'none';
    document.querySelector('.klaviyo-notify-step-2').style.display = 'flex';
};

const form = document.getElementById('klaviyoNotifyForm');
form.addEventListener('submit', klaviyoNotifyForm);